// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","fontFamily":"Lato, Open Sans"};